import React from 'react'
import Urls from 'common/urls'

import { Center, Section } from '../styled'

import { SectionTitle, CTAButton } from './styled'

const FooterCTASection = () => {
  return (
    <Section dark>
      <Center>
        <SectionTitle>
          Ready to learn about your fertility?
        </SectionTitle>
        <a
          href={Urls.kit}
          target="_blank"
          rel="noreferrer noopener"
        >
          <CTAButton>Buy a kit</CTAButton>
        </a>
      </Center>
    </Section>
  )
}

export default FooterCTASection
